import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import useSnackbarAlert from "../../../utils/snackbarHandlers";
import { useNavigate } from "react-router-dom";
import "../../LotterySystem/lotterySystem.css";
import GetInTouchForm from '../../LotterySystem/GetInTouchForm';

interface ContactDetails {
  name: string;
  email: string;
  phoneNumber: string;
  subject: string;
  message: string;
  status: string,
};

interface EditContactFormProps {
  contactUsData: any;
  id: any;
}

const EditContactForm: React.FC<EditContactFormProps> = ({ contactUsData, id }) => {
  const { t } = useTranslation('translation');
  const [loading, setLoading] = useState<boolean>(false);
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
  const navigate = useNavigate();

  const onSubmit = (value: ContactDetails) => {
    const fileHeaders = {
      accept: "application/json",
      "Accept-Language": "en-US,en;q=0.8",
      "Content-Type": "application/json",
    };
    const body = {
      name: value.name,
      email: value.email,
      phoneNumber: value.phoneNumber,
      subject: value.subject,
      message: value.message,
      status: value.status,
    };

    axios
      .put(`${apiBaseURL}/api/contact/updateContact?id=${id}`, body, { headers: fileHeaders })
      .then((data: any) => {
        if (data?.status === 200) {
          showSuccessMessage(t("contactUpdatedSuccessfully", "Contact Updated Successfully"))
          navigate('/admin/contacts');
        }
      })
      .catch((err: any) =>
        showErrorMessage(t("somethingWentWrong"))
      )
      .finally(() => {
        setLoading(false);
      });
  }

  return (
   <GetInTouchForm contactUsData={contactUsData} edit={true} formSubmit={onSubmit} />
  );
}

export default EditContactForm;